import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import { lazy } from "react";

const PrivacyPolicy = lazy(() => import("../pages/privacy/page"));
const ComplaintsPage = lazy(() => import("../pages/complaints/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/complaints",
    element: <ComplaintsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
